import { window } from "global";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactSVG from "react-svg";
import { useEffect, useGlobal } from "reactn";
import MediaQuery from "components/MediaQuery";
import SearchBar from "components/SearchBar";
import { SignupButton } from "components/Accounts/Signup";
import { LoginButton } from "components/Accounts/Login";
import { useQueryString, useSideNav, useScrollPosition, SCROLL_DIRECTION_DOWN } from "hooks/general-hooks";
import { useUserPremiumState } from "lib/hooks/userHooks";
import UserProfileLink from "./Masthead/UserProfileLink";
import NotificationContainer from "./Masthead/Notifications/NotificationContainer";
import SettingsContainer from "./Masthead/Settings/views/SettingsContainer";
import { GET_USER_STATE } from "api/graphql/queries";
import { useLoginState } from "lib/hooks/userHooks";
import { useQuery } from "@apollo/client";
import { ReactComponent as LiveGameIcon } from "svg/live-game-icon.svg";
import { ReactComponent as DoubleHearts } from "svg/double-hearts-outline.svg";
import { ReactComponent as WindowsIcon } from "svg/windows.svg";
import { ReactComponent as DownArrow } from "svg/down-arrow.svg";
import { ReactComponent as BlueManPlus } from "svg/blue-man-plus.svg";
import { ReactComponent as SearchIconWhite } from "svg/search-icon-2-white.svg";
import { ReactComponent as SearchIconWhiteLightMode } from "svg/search-icon-2-light-mode.svg";
import { MOBILE_SLIDE_GLOBAL_KEY, WINDOW_BREAKPOINTS } from "lib/constants";
import { isWindowBreakpoint, getAppDownloadUrl } from "lib/general-helper";
import { SCROLL_DIRECTION_UP } from "../hooks/general-hooks";
import FeedbackIcon from "./Masthead/Feedback/FeedbackIcon";
import LightModeToggle from "./Masthead/LightModeToggle/LightModeToggle";
import { useLightMode } from "hooks/general-hooks";

const Masthead = (props) => {
  const location = useLocation();
  const queryString = useQueryString();
  const [loggingIn] = useGlobal("loggingIn");
  const [authToken] = useGlobal("authToken");
  const [windowBreakpoint] = useGlobal("responsive");
  const [manualSideNav, setManualSideNav] = useGlobal("manualSideNav");
  const [verificationBar] = useGlobal("verificationBar");
  const [expandedSideNav, setExpandedSideNav] = useSideNav();
  const interactedWithSideNav = windowBreakpoint === "DESKTOP_LARGE" || manualSideNav;
  const { lightModeOn } = useLightMode();
  const isLoggedIn = useLoginState();

  const { isPremium } = useUserPremiumState();
  const { data: userData } = useQuery(GET_USER_STATE);
  const state = userData ? userData.getState : null;
  const summoner =
    state && state.lolSettings && state.lolSettings.summoners && state.lolSettings.summoners.length > 0
      ? state.lolSettings.summoners[0]
      : null;
  const region = summoner ? summoner.regionId : "";
  const summonerName = summoner ? summoner.summonerName : "";

  const toggledSideNav = () => {
    !manualSideNav && setManualSideNav(true);
    (interactedWithSideNav || !expandedSideNav) && setExpandedSideNav(!expandedSideNav, { saveToggle: true });
  };

  const collapsed = expandedSideNav ? "expanded" : "collapsed";

  const renderUserLink = () => {
    if (!window || loggingIn) {
      return null;
    } else if (authToken) {
      return <UserProfileLink />;
    } else {
      return (
        <div className="masthead_account-buttons">
          {/* <SignupButton>
            <div className="btn-blue btn-blue_hover" style={{ minHeight: "30px" }}>
              Create Account
            </div>
          </SignupButton> */}
          <LoginButton>
            <div className="btn-blue btn-blue_hover" style={{ height: "40px", width: "100px" }}>
              Log In
            </div>
          </LoginButton>
        </div>
      );
    }
  };

  const verificationBarActive = verificationBar ? "verification-bar-active" : "";

  // Auto hide nav on location change
  useEffect(() => {
    setExpandedSideNav(false);
  }, [location]);

  if (!window) {
    return (
      <div id="masthead">
        <div className={`masthead-container`}></div>
      </div>
    );
  }

  if (isLoggedIn) {
    return (
      <div id="masthead" className={`${verificationBarActive}`}>
        <div className={"masthead-container " + collapsed}>
          <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
            {location.pathname !== "/app" && (
              <Link className="" to="/app?utm_source=uggtop" style={{ display: "flex" }}>
                <div className="download-now-button">
                  <DownArrow className="button-down-arrow" />
                  <span>Download Now</span>
                </div>
              </Link>
            )}
          </MediaQuery>
          <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
            <div className="masthead-search-bar-container">
              {location.pathname !== "/" && !location.pathname.includes("lg-splash") && (
                <SearchBar
                  materialDesign
                  // placeholder={["MOBILE_SMALL", "MOBILE_MEDIUM", "MOBILE_LARGE"].includes(windowBreakpoint) ? "Search a Champion" : ""}
                  placeholder={"Search Summoner or Champion"}
                  isMasthead
                />
              )}
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <div className="masthead-search-bar-container" />
          </MediaQuery>
          <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
            <div className={"masthead-right"} style={{ paddingRight: "24px" }}>
              <LightModeToggle />
              <SettingsContainer />
              <FeedbackIcon />
              <NotificationContainer />
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <div className={"masthead-right"} style={{ paddingRight: "24px" }}>
              {location.pathname !== "/" &&
                !location.pathname.includes("lg-splash") &&
                (lightModeOn ? (
                  <SearchIconWhiteLightMode style={{ height: "16px", width: "16px" }} onClick={toggledSideNav} />
                ) : (
                  <SearchIconWhite style={{ height: "16px", width: "16px" }} onClick={toggledSideNav} />
                ))}
              <SettingsContainer />
              <FeedbackIcon />
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_SMALL"></MediaQuery>
        </div>
      </div>
    );
  } else {
    return (
      <div id="masthead" className={`${verificationBarActive}`}>
        <div className={"masthead-container " + collapsed}>
          <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
            {location.pathname !== "/app" && (
              <Link className="" to="/app?utm_source=uggtop" style={{ display: "flex" }}>
                <div className="download-now-button">
                  <DownArrow className="button-down-arrow" />
                  <span>Download Now</span>
                </div>
              </Link>
            )}
          </MediaQuery>
          <div className="masthead-search-bar-container">
            {location.pathname !== "/" && !location.pathname.includes("lg-splash") && (
              <SearchBar
                materialDesign
                // placeholder={["MOBILE_SMALL", "MOBILE_MEDIUM", "MOBILE_LARGE"].includes(windowBreakpoint) ? "Search a Champion" : ""}
                placeholder={"Search Summoner or Champion"}
                isMasthead
              />
            )}
          </div>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <div className="masthead-right">
              <LightModeToggle />
              <SettingsContainer />
              <FeedbackIcon />
              <NotificationContainer />
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_LARGE" max="MOBILE_LARGE">
            <div className="masthead-right" style={{ marginLeft: "-16px" }}>
              <SettingsContainer />
              <FeedbackIcon />
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <div className="masthead-right" style={{ marginLeft: "-16px" }}>
              {location.pathname !== "/" &&
                !location.pathname.includes("lg-splash") &&
                (lightModeOn ? (
                  <SearchIconWhiteLightMode style={{ height: "16px", width: "16px" }} onClick={toggledSideNav} />
                ) : (
                  <SearchIconWhite style={{ height: "16px", width: "16px" }} onClick={toggledSideNav} />
                ))}
              <SettingsContainer />
              <FeedbackIcon />
            </div>
          </MediaQuery>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <div className="masthead_account">{renderUserLink()}</div>
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
            <div className="masthead_blue-man">
              <Link to={"/login"}>
                <BlueManPlus />
              </Link>
            </div>
          </MediaQuery>
        </div>
      </div>
    );
  }

  // return (
  //   <div id="masthead" className={`${verificationBarActive}`}>
  //     <div className={`masthead-container`}>
  //       <div className="logo-nav">

  //       </div>
  //     </div>
  //   </div>
  // )

  // return (
  //   <div id="masthead" className={`${verificationBarActive}`}>
  //     <div className={`masthead-container`}>
  //       <div className="logo-nav">
  //         <div id="side-nav_toggle" onClick={toggledSideNav}>
  //           <ReactSVG
  //             wrapperClassName="react-svg icon"
  //             path={
  //               interactedWithSideNav && expandedSideNav
  //                 ? "https://static.bigbrain.gg/assets/ugg/logo/MenuToClose.svg"
  //                 : "https://static.bigbrain.gg/assets/ugg/logo/MenuToOpen.svg"
  //             }
  //           />
  //         </div>
  //         <Link to="/" style={{ display: "flex", alignItems: "center" }}>
  //           <MediaQuery min="TABLET" max="DESKTOP_LARGE">
  //             <img
  //               width={81}
  //               className="ugg-logo"
  //               src={
  //                 lightModeOn
  //                   ? "https://static.bigbrain.gg/assets/ugg/logo/ugg-logo-dark.svg"
  //                   : "https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg"
  //               }
  //               alt="U.GG"
  //             />
  //           </MediaQuery>
  //         </Link>
  //       </div>
  //       <MediaQuery min="DESKTOP_MEDIUM" max="DESKTOP_LARGE">
  //         {location.pathname !== "/app" && (
  //           <Link className="masthead_app-download-btn" to="/app?utm_source=uggtop">
  //             <WindowsIcon className="windows-icon" />
  //             <span>Download App</span>
  //           </Link>
  //         )
  //         }
  //       </MediaQuery>
  //       <div className="masthead-search-bar-container">
  //         {location.pathname !== "/" && !location.pathname.includes("lg-splash") && (
  //           <SearchBar
  //             materialDesign
  //             placeholder={["MOBILE_SMALL", "MOBILE_MEDIUM", "MOBILE_LARGE"].includes(windowBreakpoint) ? "Search a Champion" : ""}
  //             isMasthead
  //           />
  //         )}
  //       </div>
  //       <MediaQuery min="MOBILE_MEDIUM" max="DESKTOP_LARGE">
  //         <div className="masthead-right">
  //           <LightModeToggle />
  //           {!loggingIn && !isPremium && (
  //             <Link className="btn-blue btn-blue_hover masthead_support-us-btn" to="/support-us">
  //               <DoubleHearts /> Support Us
  //             </Link>
  //           )}
  //           <div className="masthead_account">{renderUserLink()}</div>
  //           <div className="live-game-shortcut">
  //             {summonerName && (
  //               <div className="masthead_livegame" style={{ marginTop: "2px" }}>
  //                 <Link to={`/lol/profile/${region}/${summonerName}/live-game`}>
  //                   <LiveGameIcon width="16px" />
  //                 </Link>
  //               </div>
  //             )}
  //             {!summonerName && (
  //               <div className="masthead_livegame" style={{ marginTop: "2px" }}>
  //                 <Link to={`/lg-splash`}>
  //                   <LiveGameIcon width="16px" />
  //                 </Link>
  //               </div>
  //             )}
  //           </div>
  //           <NotificationContainer />
  //           <FeedbackIcon />
  //           <SettingsContainer />
  //         </div>
  //       </MediaQuery>
  //       <MediaQuery min="MOBILE_SMALL" max="MOBILE_SMALL">
  //         <div className="masthead-right" style={{ marginLeft: "-16px" }}>
  //           <SettingsContainer />
  //         </div>
  //       </MediaQuery>
  //     </div>
  //   </div>
  // );
};

export default Masthead;
